import React, { useEffect, useState } from 'react';
import { getSystemVersion, SystemVersion as SystemVersionInfo } from '../services/systemService';
import { themed } from '../ui/theme';

const versionTextClass = themed({
  minimal: 'text-[11px] text-blue-100/70',
  saas: 'text-[11px] text-gray-400 dark:text-slate-500',
});

/**
 * Discreet build-version label for the sidebar footer. Confirms which backend
 * build is deployed. Fails silently if the endpoint is unavailable.
 */
const SystemVersion: React.FC = () => {
  const [info, setInfo] = useState<SystemVersionInfo | null>(null);

  useEffect(() => {
    let active = true;
    getSystemVersion()
      .then((data) => {
        if (active) setInfo(data);
      })
      .catch(() => {
        /* endpoint unavailable — hide the label */
      });
    return () => {
      active = false;
    };
  }, []);

  if (!info) return null;

  const label = `v${info.version}${info.buildTime && info.buildTime !== 'dev' ? ` · ${info.buildTime}` : ''}`;

  return (
    <div className={`mt-3 text-center ${versionTextClass}`} title={`Build: ${info.buildTime}`}>
      SIGEM {label}
    </div>
  );
};

export default SystemVersion;
